import React, { useState, useEffect } from "react";
import { Global } from "../helpers/Global";

// --- Toast interna (idéntica al estilo que usas en JornadaPage) ---
const Toast = ({ type = "info", children }) => {
  const [top, setTop] = useState(90);

  useEffect(() => {
    const calcTop = () => {
      const header = document.querySelector(".header");
      const navi = document.querySelector(".navi");
      const h = (header?.offsetHeight || 0) + (navi?.offsetHeight || 0);
      setTop(h > 0 ? h + 12 : 90);
    };
    calcTop();
    window.addEventListener("resize", calcTop);
    return () => window.removeEventListener("resize", calcTop);
  }, []);

  const base = {
    position: "fixed",
    top,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 9999,
    padding: "12px 18px",
    borderRadius: 8,
    fontWeight: 600,
    boxShadow: "0 8px 24px rgba(0,0,0,.12)",
    pointerEvents: "none",
    maxWidth: "90vw",
    textAlign: "center",
  };

  const variants = {
    ok:    { background: "#e7f8ed", color: "#0f5132", border: "1px solid #b6f0c6" },
    error: { background: "#fdeceb", color: "#842029", border: "1px solid #f5c2c7" },
    info:  { background: "#e8f6ff", color: "#084298", border: "1px solid #b6d9ff" },
  };

  return <div style={{ ...base, ...(variants[type] || {}) }}>{children}</div>;
};

export const CrearDepartamento = () => {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const [toast, setToast] = useState(null);
  const toastDurationMs = 3500;

  const showToast = (type, text, ms = toastDurationMs) => {
    setToast({ type, text });
    window.setTimeout(() => setToast(null), ms);
  };

  const crearDepartamento = async (e) => {
    e.preventDefault();

    if (!nombre.trim()) {
      showToast("error", "❌ Debes indicar el nombre del departamento");
      return;
    }

    try {
      const response = await fetch(Global.url + "departamentos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          nombre: nombre.trim(),
          descripcion: descripcion.trim(),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setNombre("");
        setDescripcion("");
        showToast("ok", "Departamento creado correctamente");
      } else {
        showToast("error", data.message || "❌ Error al crear el departamento");
      }
    } catch (error) {
      console.error("Error al crear departamento:", error);
      showToast("error", "❌ Error inesperado al crear el departamento");
    }
  };

  return (
    <div className="form-crear-usuario">
      {toast && <Toast type={toast.type}>{toast.text}</Toast>}

      <h2>Registrar Departamento</h2>

      <form onSubmit={crearDepartamento} className="formulario-usuario">
        <div className="form-group">
          <label>Nombre del departamento:</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Descripción (opcional):</label>
          <textarea
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            rows={3}
          />
        </div>

        <button className="btn-login" type="submit">
          Guardar Departamento
        </button>
      </form>
    </div>
  );
};
